// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/paragraph/ParagraphCodeBlock.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/paragraph/ParagraphCodeBlock.tsx");
  import.meta.hot.lastModified = "1732036225885.319";
}
// REMIX HMR END

import { CodeBlock, atomOneDark } from "react-code-blocks";
import Heading from "../Heading";
export default function CodeBlockComponent({
  textOptional,
  titleOptional,
  code,
  language,
  showLineNumbers
}) {
  return <section className="w-full not-wysiwyg">
      {titleOptional && <Heading tag="h2">
          {titleOptional}
        </Heading>}
      {textOptional && <div className="text-neutral-500 mb-8" dangerouslySetInnerHTML={{
      __html: textOptional.processed
    }} />}
      <div className="max-w-6xl mx-auto children:!rounded-md">
        <CodeBlock text={code} language={language} showLineNumbers={showLineNumbers} theme={atomOneDark} wrapLines />
      </div>
    </section>;
}
_c = CodeBlockComponent;
var _c;
$RefreshReg$(_c, "CodeBlockComponent");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;